import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { requireAdmin } from '@/lib/auth-guards'
import { AttendanceHistoryPage } from '@/features/attendance/attendance-history-page'

const checkInsSearchSchema = z.object({
  date: z.string().optional().catch(''),
  startDate: z.string().optional().catch(''),
  endDate: z.string().optional().catch(''),
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
})

export const Route = createFileRoute('/_authenticated/check-ins/by-date')({
  beforeLoad: requireAdmin,
  validateSearch: checkInsSearchSchema,
  component: AttendanceHistoryPage,
})
